export default "/images/icon-arow-down-grey.svg?651fb367e8f60b603f62859a4d2cf0ba";